export const Refund = () => {
  return (
    <div id="refund" className={'policy'}>
        <h1>{'Refund Policy'}</h1>
        <br/>
        <p>Thanks for subscribing to our services at ReFast.</p>
        <p>We offer a full money-back guarantee for all purchases made on our app.</p>
        <p>Any money added to wallet is NOT transferable and NOT refundable as per RBI guidelines. You can only keep upto 5000 rupees in your wallet.</p>
        <p>If you did not get the service you paid for, you can get your money back no questions asked.</p>
        <p>You are eligible for a full reimbursement within 14 calendar days of your purchase. After the 14-day period you will no longer be eligible and won't be able to receive a refund. </p>
        <p>If you have any additional questions or would like to request a refund, feel free to contact us at <b>refastinfo@gmail.com</b></p>
    </div>
  );
};
